import { useEffect } from 'react';

const IdleTimeoutManager = ({ onLogout, TIMEOUT = 1000 * 60 * 30 }) => {
  const IDLE_TIMEOUT = TIMEOUT; // 1 minute
  const ACTIVE_FLAG_KEY = 'isAnyTabActive';

  useEffect(() => {
    // Set the initial active tab flag,
    localStorage.setItem(ACTIVE_FLAG_KEY, 'true');

    const handleVisibilityChange = () => {
      // Update the active tab flag based on tab visibility
      localStorage.setItem(ACTIVE_FLAG_KEY, document.visibilityState === 'visible' ? 'true' : 'false');
    };

    const interval = setInterval(() => {
      const isActive = localStorage.getItem(ACTIVE_FLAG_KEY) === 'true';
      if (!isActive) {
        onLogout();
      }
    }, IDLE_TIMEOUT);

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };

    // eslint-disable-next-line
  }, [onLogout]);

  return null;
};

export default IdleTimeoutManager;
